import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex justify-end mb-3" }
const _hoisted_2 = { class: "text-h4 font-weight-bold" }
const _hoisted_3 = { class: "text-h4 font-weight-bold" }
const _hoisted_4 = { class: "text-h4 font-weight-bold" }
const _hoisted_5 = { class: "d-flex justify-space-between mb-1 text-body-2" }
const _hoisted_6 = { class: "text-h6" }
const _hoisted_7 = { class: "text-h6" }

import { ref, computed, onMounted } from 'vue'
import axios from '@/plugins/axios'

interface Stats {
  total: number
  laws: number
  cases: number
  cases_enriched: number
  bm25_size_mb: number
  last_indexed: string | null
}


export default /*@__PURE__*/_defineComponent({
  __name: 'StatsPanel',
  setup(__props) {

const API_BASE = process.env.VUE_APP_API_BASE_URL as string

const stats   = ref<Stats | null>(null)
const loading = ref(false)
const error   = ref<string | null>(null)

const enrichPercent = computed(() => {
  if (!stats.value || stats.value.cases === 0) return 0
  return Math.round((stats.value.cases_enriched / stats.value.cases) * 100)
})

async function load() {
  loading.value = true
  error.value   = null
  try {
    const res = await axios.get(`${API_BASE}/admin/parser/stats`)
    stats.value = res.data
  } catch (e: any) {
    error.value = e?.response?.data?.error ?? e?.message ?? 'Hata'
  } finally {
    loading.value = false
  }
}

onMounted(load)

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_btn, {
        variant: "outlined",
        size: "small",
        loading: loading.value,
        onClick: load
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createTextVNode(" Yenile ", -1)
        ]))]),
        _: 1
      }, 8, ["loading"])
    ]),
    (error.value)
      ? (_openBlock(), _createBlock(_component_v_alert, {
          key: 0,
          type: "error",
          class: "mb-4",
          closable: "",
          "onClick:close": _cache[0] || (_cache[0] = ($event: any) => (error.value = null))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(error.value), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (stats.value)
      ? (_openBlock(), _createBlock(_component_v_row, { key: 1 }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "12",
              sm: "4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, {
                  variant: "tonal",
                  color: "primary"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_text, { class: "text-center" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, _toDisplayString(stats.value.total.toLocaleString()), 1),
                        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "text-body-2 mt-1" }, "Toplam Chunk", -1))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "12",
              sm: "4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, {
                  variant: "tonal",
                  color: "success"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_text, { class: "text-center" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, _toDisplayString(stats.value.laws.toLocaleString()), 1),
                        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "text-body-2 mt-1" }, "Yasa / Tüzük", -1))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "12",
              sm: "4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, {
                  variant: "tonal",
                  color: "info"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_text, { class: "text-center" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_4, _toDisplayString(stats.value.cases.toLocaleString()), 1),
                        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "text-body-2 mt-1" }, "Mahkeme Kararı", -1))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "12" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_title, { class: "text-body-1" }, {
                      default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                        _createTextVNode("Karar Zenginleştirme", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_v_card_text, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("span", null, _toDisplayString(stats.value.cases_enriched.toLocaleString()) + " / " + _toDisplayString(stats.value.cases.toLocaleString()), 1),
                          _createElementVNode("span", null, _toDisplayString(enrichPercent.value) + "%", 1)
                        ]),
                        _createVNode(_component_v_progress_linear, {
                          "model-value": enrichPercent.value,
                          color: "primary",
                          rounded: "",
                          height: "8"
                        }, null, 8, ["model-value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "12",
              sm: "6"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_text, null, {
                      default: _withCtx(() => [
                        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "text-overline" }, "BM25 İndeks Boyutu", -1)),
                        _createElementVNode("div", _hoisted_6, _toDisplayString(stats.value.bm25_size_mb) + " MB", 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "12",
              sm: "6"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_text, null, {
                      default: _withCtx(() => [
                        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "text-overline" }, "Son İndeks Zamanı", -1)),
                        _createElementVNode("div", _hoisted_7, _toDisplayString(stats.value.last_indexed ? new Date(stats.value.last_indexed).toLocaleString('tr-TR') : '—'), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : (loading.value)
        ? (_openBlock(), _createBlock(_component_v_row, { key: 2 }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (n) => {
                return _createVNode(_component_v_col, {
                  key: n,
                  cols: "12",
                  sm: "4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_skeleton_loader, { type: "card" })
                  ]),
                  _: 1
                })
              }), 64))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
  ]))
}
}

})